'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Page = require('./Page-ae7dfc7c.js');
require('react');
require('./index-fccd5f88.js');
require('./injectGlobalCss-bc8cf911.js');



exports.PageWrapper = Page.PageWrapper;
